import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.trim.js";
import { defineComponent as _defineComponent } from 'vue';
import { useNuxtApp } from '#app';
import { AccountMembershipRole, ReviewType, useGetReviewRequestQuery, useUpsertReviewRequestMutation, useListPortfolioVentureLinksForReviewQuery, useListUsersQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'RequestDialog',
  props: {
    initialVentureIds: null,
    portfolioId: null,
    reviewRequestId: null,
    initialReviewerIds: null,
    initialTitle: null,
    initialDescription: null
  },
  emits: ['success'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useNuxtApp = useNuxtApp(),
      $i18n = _useNuxtApp.$i18n;
    var dialogOpen = ref(false);
    var selectedVentureIds = ref([]);
    var reviewerAssignmentMode = ref('ALL');
    var selectedReviewerIds = ref([]);
    var requestTitle = ref('');
    var description = ref('');
    var titleError = ref(false);
    var reviewersError = ref(false);
    var submitting = ref(false);
    var isEditMode = computed(function () {
      return Boolean(props.reviewRequestId);
    });
    var _useUpsertReviewReque = useUpsertReviewRequestMutation({}),
      upsertReviewRequest = _useUpsertReviewReque.mutate;
    var listDataEnabled = computed(function () {
      return dialogOpen.value && !!props.portfolioId;
    });
    var editDataEnabled = computed(function () {
      return dialogOpen.value && !!props.reviewRequestId;
    });
    var _useListPortfolioVent = useListPortfolioVentureLinksForReviewQuery(computed(function () {
        return {
          portfolioId: props.portfolioId
        };
      }), computed(function () {
        return {
          enabled: listDataEnabled.value
        };
      })),
      venturesResult = _useListPortfolioVent.result,
      venturesLoading = _useListPortfolioVent.loading;
    var portfolioVentureOptions = computed(function () {
      var _venturesResult$value, _venturesResult$value2;
      var links = (_venturesResult$value = (_venturesResult$value2 = venturesResult.value) === null || _venturesResult$value2 === void 0 ? void 0 : _venturesResult$value2.listPortfolioVentureLinks) !== null && _venturesResult$value !== void 0 ? _venturesResult$value : [];
      return links.map(function (link) {
        var _link$venture$id, _link$venture, _link$venture2;
        return {
          id: String((_link$venture$id = (_link$venture = link.venture) === null || _link$venture === void 0 ? void 0 : _link$venture.id) !== null && _link$venture$id !== void 0 ? _link$venture$id : link.ventureId),
          name: ((_link$venture2 = link.venture) === null || _link$venture2 === void 0 ? void 0 : _link$venture2.name) || String(link.ventureId)
        };
      }).sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    });
    var _useListUsersQuery = useListUsersQuery(computed(function () {
        return {
          accountId: props.portfolioId,
          limit: 200,
          offset: 0
        };
      }), computed(function () {
        return {
          enabled: listDataEnabled.value
        };
      })),
      usersResult = _useListUsersQuery.result,
      reviewersLoading = _useListUsersQuery.loading;
    var _useGetReviewRequestQ = useGetReviewRequestQuery(computed(function () {
        return {
          id: String(props.reviewRequestId)
        };
      }), computed(function () {
        return {
          enabled: editDataEnabled.value
        };
      })),
      reviewRequestResult = _useGetReviewRequestQ.result;
    var formatReviewerLabel = function formatReviewerLabel(user) {
      var name = [user.firstName, user.lastName].filter(Boolean).join(' ').trim();
      return name ? "".concat(name, " (").concat(user.email, ")") : user.email;
    };
    var reviewerOptions = computed(function () {
      var _usersResult$value$li, _usersResult$value;
      var users = (_usersResult$value$li = (_usersResult$value = usersResult.value) === null || _usersResult$value === void 0 ? void 0 : _usersResult$value.listUsers) !== null && _usersResult$value$li !== void 0 ? _usersResult$value$li : [];
      return users.filter(function (user) {
        var _user$membershipRoles;
        return (_user$membershipRoles = user.membershipRolesForAccount) === null || _user$membershipRoles === void 0 ? void 0 : _user$membershipRoles.includes(AccountMembershipRole.Reviewer);
      }).map(function (user) {
        return {
          id: user.id,
          label: formatReviewerLabel(user)
        };
      });
    });
    var resetForm = function resetForm() {
      selectedVentureIds.value = _toConsumableArray(props.initialVentureIds);
      selectedReviewerIds.value = _toConsumableArray(props.initialReviewerIds || []);
      reviewerAssignmentMode.value = selectedReviewerIds.value.length ? 'SPECIFIC' : 'ALL';
      requestTitle.value = props.initialTitle || '';
      description.value = props.initialDescription || '';
      titleError.value = false;
      reviewersError.value = false;
    };
    watch(dialogOpen, function (isOpen) {
      if (isOpen) {
        resetForm();
      }
    });
    watch(function () {
      var _reviewRequestResult$;
      return (_reviewRequestResult$ = reviewRequestResult.value) === null || _reviewRequestResult$ === void 0 ? void 0 : _reviewRequestResult$.getReviewRequest;
    }, function (request) {
      if (!dialogOpen.value || !request || !isEditMode.value) {
        return;
      }
      requestTitle.value = request.title || '';
      description.value = request.description || '';
      selectedVentureIds.value = (request.ventures || []).map(function (v) {
        return String(v.ventureId);
      });
      selectedReviewerIds.value = (request.assignedReviewers || []).map(function (r) {
        return String(r.id);
      });
      reviewerAssignmentMode.value = selectedReviewerIds.value.length ? 'SPECIFIC' : 'ALL';
    });
    var close = function close() {
      dialogOpen.value = false;
    };
    var clearDescription = function clearDescription() {
      description.value = '';
    };
    var copyDescription = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (description.value) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return navigator.clipboard.writeText(description.value);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function copyDescription() {
        return _ref2.apply(this, arguments);
      };
    }();
    var submit = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var input;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (requestTitle.value.trim()) {
                _context2.next = 3;
                break;
              }
              titleError.value = true;
              return _context2.abrupt("return");
            case 3:
              if (selectedVentureIds.value.length) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return");
            case 5:
              if (!(reviewerAssignmentMode.value === 'SPECIFIC' && !selectedReviewerIds.value.length)) {
                _context2.next = 8;
                break;
              }
              reviewersError.value = true;
              return _context2.abrupt("return");
            case 8:
              submitting.value = true;
              _context2.prev = 9;
              input = {
                ventureIds: selectedVentureIds.value,
                reviewType: ReviewType.TheoryOfChange,
                title: requestTitle.value.trim()
              };
              if (props.reviewRequestId) {
                input.id = props.reviewRequestId;
              }
              if (description.value) {
                input.description = description.value;
              }
              input.reviewerUserIds = reviewerAssignmentMode.value === 'SPECIFIC' ? selectedReviewerIds.value : [];
              _context2.next = 16;
              return upsertReviewRequest({
                input: input
              });
            case 16:
              window.$nuxt.$emit('userMsg', {
                color: 'green',
                message: $i18n.t(isEditMode.value ? 'successUpdate' : 'successCreate')
              });
              emit('success');
              close();
              _context2.next = 24;
              break;
            case 21:
              _context2.prev = 21;
              _context2.t0 = _context2["catch"](9);
              window.$nuxt.$emit('userError', {
                message: (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message) || String(_context2.t0)
              });
            case 24:
              _context2.prev = 24;
              submitting.value = false;
              return _context2.finish(24);
            case 27:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[9, 21, 24, 27]]);
      }));
      return function submit() {
        return _ref3.apply(this, arguments);
      };
    }();
    return {
      __sfc: true,
      props: props,
      emit: emit,
      $i18n: $i18n,
      dialogOpen: dialogOpen,
      selectedVentureIds: selectedVentureIds,
      reviewerAssignmentMode: reviewerAssignmentMode,
      selectedReviewerIds: selectedReviewerIds,
      requestTitle: requestTitle,
      description: description,
      titleError: titleError,
      reviewersError: reviewersError,
      submitting: submitting,
      isEditMode: isEditMode,
      upsertReviewRequest: upsertReviewRequest,
      listDataEnabled: listDataEnabled,
      editDataEnabled: editDataEnabled,
      venturesResult: venturesResult,
      venturesLoading: venturesLoading,
      portfolioVentureOptions: portfolioVentureOptions,
      usersResult: usersResult,
      reviewersLoading: reviewersLoading,
      reviewRequestResult: reviewRequestResult,
      formatReviewerLabel: formatReviewerLabel,
      reviewerOptions: reviewerOptions,
      resetForm: resetForm,
      close: close,
      clearDescription: clearDescription,
      copyDescription: copyDescription,
      submit: submit
    };
  }
});